import type { NotificationAreaCode } from "@/constants/api.notifications";
import type { AppNotification } from "@/features/notifications/types";

/** Domaines sans écran métier dans accueilv2 — visibles uniquement via /notifications. */
export const NOTIFICATION_AREAS_WITHOUT_DEDICATED_PAGE: readonly NotificationAreaCode[] = [
  "colis",
] as const;

const CENTER_ONLY_AREAS = new Set<NotificationAreaCode>(
  NOTIFICATION_AREAS_WITHOUT_DEDICATED_PAGE,
);

export function notificationAreaHasDedicatedPage(
  area: NotificationAreaCode | undefined,
): area is NotificationAreaCode {
  return Boolean(area && !CENTER_ONLY_AREAS.has(area));
}

export function isNotificationCenterOnly(notification: AppNotification): boolean {
  const eventType = notification.event_type ?? "";
  const entityType = notification.entity_type ?? "";

  if (eventType.startsWith("colis.") || entityType === "parcel") {
    return true;
  }

  return NOTIFICATION_AREAS_WITHOUT_DEDICATED_PAGE.some((area) =>
    eventType.startsWith(`${area}.`),
  );
}
